export default `---
slug: netherlands
country: Netherlands
countryCode: NL1
continent: Europe
year: 2022
title: "The Netherlands — My Second Home"
description: "Where I moved in 2022 for work at Swift. Bikes, canals, stroopwafels, and learning to love the rain."
thumbnail: /images/travels/NL1/nl_thumb.jpg
relatedLinks: []
---
![netherlands](/images/travels/NL1/nl_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Netherlands and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
